/**
 * Process entity filter query string to remove redundant billingActive filter when both billing status checkboxes are checked
 *
 * @param queryString Entity filter query string
 * @returns Processed query string
 */
export function processQueryString(queryString: string): string {
    const parsedQueryString = new URLSearchParams(queryString);
    const billingActiveValues = parsedQueryString.getAll('billingActive');

    if (billingActiveValues.includes('true') && billingActiveValues.includes('false')) {
        parsedQueryString.delete('billingActive');
        return parsedQueryString.toString();
    }

    return queryString;
}
